import { apiService } from "./apiService";
import ApiEndPoint from "./apiEndpoint";
import axios from 'axios';

const AI_BASE_URL = process.env.REACT_APP_AI_BASE_URL;


export const handleRegisterUser = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.REGISTER_USER, data);
    } catch (err) {
        console.warn("Registration Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleRegisterOtp = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.REGISTER_USER_OTP, data);
    } catch (err) {
        console.warn("Registration Otp Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleResentOtp = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.REGISTER_RESENT_OTP, data);
    } catch (err) {
        console.warn("Registration Otp Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleResentOtpForgot = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.FORGOT_RESENT_OTP, data);
    } catch (err) {
        console.warn("Registration Otp Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleLoginUser = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.LOGIN_USER, data);
    } catch (err) {
        console.warn("Loign Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleLoginSocial = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.LOGIN_SOCIAL, data);
    } catch (err) {
        console.warn("Loign Social Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleForgotPassword = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.FORGOT_PASSWORD, data);
    } catch (err) {
        console.warn("Loign Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleVerifyForgotOtp = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.FORGOT_OTP_VERIFY, data);
    } catch (err) {
        console.warn("Forgot OTP Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleResetPassword = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.RESET_PASSWORD, data);
    } catch (err) {
        console.warn("Forgot OTP Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleSaveChatId = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.SAVE_CHAT_ID, data);
    } catch (err) {
        console.warn("Create Chat ID Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleSaveProfile = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.SAVE_PROFILE, data);
    } catch (err) {
        console.warn("Save Profile Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleDeleteAccount = async (data) => {
    try {
        return await apiService.get(ApiEndPoint.DELETE_ACCOUNT, data);
    } catch (err) {
        console.warn("Delete account Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleLogoutAccount = async (data) => {
    try {
        return await apiService.get(ApiEndPoint.LOGOUT, data);
    } catch (err) {
        console.warn("Logout account Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleGetSubjects = async (data) => {
    try {
        return await apiService.get(ApiEndPoint.SUBJECT_LIST, data);
    } catch (err) {
        console.warn("Subject List Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleGetChatRoomHistory = async (data) => {
    try {
        return await apiService.get(ApiEndPoint.CHAT_ROOM_HISTORY, data);
    } catch (err) {
        console.warn("Chat Room History Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleGetChatHistory = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.CHAT_HISTORY, data);
    } catch (err) {
        console.warn("Chat Room History Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleSaveChat = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.CHAT_UPDATE, data);
    } catch (err) {
        console.warn("Chat Update Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleChangePassWithOld = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.CHANGE_PASSWORD, data);
    } catch (err) {
        console.warn("Password Change Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleRenameChatRoom = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.CHAT_ROOM_RENAME, data);
    } catch (err) {
        console.warn("Chat Rename Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handlePinnedChatRoom = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.TOGGLE_PINNED, data);
    } catch (err) {
        console.warn("Chat Rename Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleGetPlansList = async (data) => {
    try {
        return await apiService.get(ApiEndPoint.GET_PLAN_LIST, data);
    } catch (err) {
        console.warn("Save Profile Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleCreateCheckoutSession = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.CREATE_CHECKOUT_SESSION, data);
    } catch (err) {
        console.warn("Create Checkout Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleGetPaymentStatus = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.PAYMENT_STATUS, data);
    } catch (err) {
        console.warn("Payment Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleCreatSubscription = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.CREATE_SUBSCRIPTION, data);
    } catch (err) {
        console.warn("Creat Subscription Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleGetFeedbackOption = async (data) => {
    try {
        return await apiService.get(ApiEndPoint.FEEDBACK_OPTION, data);
    } catch (err) {
        console.warn("Feedback Option Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleGetGenerateQuiz = async (data) => {
    try {
        return await apiService.get(ApiEndPoint.GENERATE_QUIZ, data);
    } catch (err) {
        console.warn("Feedback Option Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleSubmitQuiz = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.SUBMIT_QUIZ, data);
    } catch (err) {
        console.warn("Submit Quiz Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleSubmitFeedback = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.SEND_FEEDBACK, data);
    } catch (err) {
        console.warn("Submit Feedback Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleSubmitContact = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.SEND_CONTACT, data);
    } catch (err) {
        console.warn("Submit Contact Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handlePaymentHistory = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.PAYMENT_HISTORY, data);
    } catch (err) {
        console.warn("PAYMENT HISTORY Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleSampleQuestion = async (data) => {
    try {
        return await apiService.get(ApiEndPoint.SAMPLE_QUESTION, data);
    } catch (err) {
        console.warn("Sample Question Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleActivePlan = async (data) => {
    try {
        return await apiService.get(ApiEndPoint.ACTIVE_PLAN, data);
    } catch (err) {
        console.warn("My plan Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleCancelActiveSubscription = async (data) => {
    try {
        return await apiService.get(ApiEndPoint.CANCEL_SUBSCRIPTION, data);
    } catch (err) {
        console.warn("CANCEL SUBSCRIPTION Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleGetfaqs = async (data) => {
    try {
        return await apiService.get(ApiEndPoint.FAQS, data);
    } catch (err) {
        console.warn("CANCEL SUBSCRIPTION Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
export const handleAiResponse = async (data) => {
    try {
        const response = await axios.post(`${AI_BASE_URL}${ApiEndPoint.AI_CHAT}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'X-API-Key': process.env.REACT_APP_AI_TOKEN, // Replace with actual token if needed
            },
        });
        return response; // Return only the data part of the response
    } catch (err) {
        console.error("AI Chat Error:", err.response?.data || err.message);
        return err.response || err.message; // Re-throw error for handling in calling functions
    }
};
export const handleFeedbackFlow = async (data) => {
    try {
        return await apiService.post(ApiEndPoint.FEEDBACK_FLOW, data);
    } catch (err) {
        console.warn("Submit Feedback Error:", err);
        return err; // Re-throw error for better handling in calling functions
    }
};
